import { render, staticRenderFns } from "./Imofalform3itemsGrid.vue?vue&type=template&id=4a605237"
import script from "./Imofalform3itemsGrid.vue?vue&type=script&lang=js"
export * from "./Imofalform3itemsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports